const staticData = {
	loaderDelayTime: 0,
	messageDelayTime: 0,
	message: 'Loading'
};

export { staticData };
